import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from "./logo.png";
const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-container pt-5">
      <Tilt
        glareEnable={true}
        glareMaxOpacity={0.25}
        scale={1.05}
        tiltMaxAngleX={10}
        tiltMaxAngleY={10}
      >
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
          <div className="card-face card-front p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
              <div className=" d-flex align-items-center justify-content-center   ">
                <img
                  src={logo}
                  className="rounded-2 bg-white p-0"
                  style={{ width: "180px" }}
                  height="auto"
                  alt=""
                />{" "}
              </div>{" "}
              SIGMA ENVIROTECH SYSTEM
            </h5>

            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <div>
                  <h5 className="card-name mb-1">ATUL PANDEY</h5>
                  <p className="card-role mb-1">Proprietor</p>
                  <p className="card-phone mb-0">+91 98180-74136</p>
                  <p className="card-phone mb-0">+91 97172-01129</p>
                  <p className="card-phone mb-0">+011-46074136</p>
                </div>
              </div>
              <div className="qr-code-front">
                <QRCodeSVG
                  value={`BEGIN:VCARD
VERSION:3.0
N:ATUL PANDEY
TEL:+919818074136
EMAIL:sigmaenvirotech@gmail.com
END:VCARD`}
                  size={80}
                  fgColor="#000000"
                />
              </div>
            </div>

            {/* <p className="address mt-4 small text-muted">
              <i className="fa fa-map-marker me-2"></i>
              Office No-306, 3rd Floor, RG Trade Tower, <br />
              Netaji Subhash Place, New Delhi - 110034
            </p> */}
          </div>

          {/* Back Side */}
          <div className="card-face card-back p-4">
            <h5 className="brand-title text-center d-flex align-items-center">
              <div className=" d-flex align-items-center justify-content-center me-3">
                <img
                  src={logo}
                  className="rounded-2 bg-white p-0"
                  style={{ width: "180px" }}
                  height="auto"
                  alt=""
                />{" "}
              </div>{" "}
              SIGMA ENVIROTECH SYSTEM
            </h5>
            <div className="row">
              <div className="col-sm-12">
                <p className="address  small text-muted">
                  <div>
                    {" "}
                    <i className="fa fa-map-marker me-2"></i> UG-9A,Jaina Tower
                    -1,Distt. Center Jankpuri, New Delhi-110058{" "}
                  </div>
                </p>
                <QRCodeSVG
                  value="https://maps.app.goo.gl/dHEqMSRLscKhHENSA"
                  size={60}
                  fgColor="#000000"
                />
              </div>
            </div>
          </div>
        </div>
      </Tilt>

      {/* Manual flip button */}
      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      {/* Action buttons */}
      <div
        className="d-flex flex-column gap-3 mt-5 w-75 mx-auto"
        style={{ maxWidth: "280px" }}
      >
        <a href="/atul-pandey.vcf" download className="platinum-btn">
          Add To Contacts
        </a>
        <a href="tel:+919818074136" className="platinum-btn">
          Call Now
        </a>
        <a href="mailto:sigmaenvirotech@gmail.com" className="platinum-btn">
          Email Us
        </a>
        <a
          href="https://wa.me/+919818074136"
          target="_blank"
          className="platinum-btn"
        >
          WhatsApp
        </a>

        <a
          href="https://www.sigmaenvirotechsystems.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Website-1
        </a>
        <a
          href="https://www.sigmaenvirotech.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Website-2
        </a>
        <a
          href="https://www.sigmaenv.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Website-3
        </a>
        <a
          href="https://maps.app.goo.gl/dHEqMSRLscKhHENSA"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Address Details
        </a>
        <a href="./brochure1.pdf" className="platinum-btn">Brochure</a>
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
